import { Injectable } from '@angular/core';
import { LocaleService, OptimAttributeSupplier, OptimAttributes } from '@ciam/library';
import { Observable, map, take } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LocaleProvider implements OptimAttributeSupplier {
    constructor(
        private locale: LocaleService,
    ) {}

    supply(): Observable<OptimAttributes> | OptimAttributes {
        return this.locale.watch$().pipe(take(1), map(locale => ({ locale: locale.iso })));
    }
}
